import React from "react";

interface TabItem {
  label: string | React.ReactNode;
  key: string;
  children: React.ReactNode | string;
}
interface TabsProps {
  defaultActiveTab?: string;
  items: TabItem[];
  activeKey: string;
  onChange: (key: string) => void;
}
const Tabs = (props: TabsProps) => {
  const { defaultActiveTab, items, onChange } = props;
  const activeKey = props?.activeKey || defaultActiveTab;

  const Children = items.find((item) => item.key === activeKey)?.children;

  return (
    <>
      <div className='flex items-center justify-center gap-2 rounded-[80px] bg-mono-color-lighter px-2 text-brand-color-primary-light'>
        {items.map((item) => (
          <div
            key={item.key}
            onClick={() => onChange(item.key)}
            className={`flex min-w-[80px] cursor-pointer items-center justify-center px-3 py-1 ${
              activeKey === item.key
                ? 'rounded-[64px] text-brand-color-primary-lighter'
                : ''
            }`}
            style={{
              background:
                activeKey === item.key
                  ? 'linear-gradient(95.27deg, #6B89C3 -38.36%, #1B229F 95.05%)'
                  : '',
            }}
          >
            {item.label}
          </div>
        ))}
      </div>
      <div className='w-full'>{Children}</div>
    </>
  );
};

export default Tabs;
